export default __webpack_public_path__ + "static/media/01.8d28590c.jpg";